import { useApolloClient } from "@apollo/client";
import { getDataOrNull } from "@msys/common";
import { useProjectLocationQuery } from "./useProjectLocation.generated.js";

export const useProjectLocation = (projectId: string | null) => {
  const client = useApolloClient();
  const query = useProjectLocationQuery({
    client,
    variables: { projectId: projectId ?? "" },
    skip: !projectId,
  });
  return !projectId ? null : getDataOrNull(query.data?.project)?.project;
};
